import { parseParams, initializeAttributeValues, initializeAllAttributeKeyFields, initializeAttributeKeys, addNewOptionField } from "./helpers";
const FORM_CONTAINER_ID = "#channel_form"
const KEYS_CLASSNAME = ".channel-attribute-keys"
const KEYS_ENDPOINT = "/channel_attribute_keys.json"
const BULK_UPDATE_MENU_CLASSNAME = ".channel-update-menu"

$(document).on('turbolinks:load', function() {
  initializeAllAttributeKeyFields(KEYS_CLASSNAME, KEYS_ENDPOINT);

  // setTimeout(function(){
  //   var url = '/channels_intel?'
  //   let params = new URLSearchParams(window.location.search)
  //   Rails.ajax({
  //     type: 'GET',
  //     url: url + params,
  //     dataType: 'json',
  //     success: (response) => {
  //       $('#channels_index_graphs').html(response)
  //     }
  //   })
  // }, 3000);

  if(window.location.pathname == "/channels"){
    $(BULK_UPDATE_MENU_CLASSNAME + " .bulk_menu_btn").prop('disabled', true);
  }

  $('#showThumbnails').change(function() {
    var checked = $(this).prop('checked')

    if(checked){
      $('.video-thumbnails').show();
    } else {
      $('.video-thumbnails').hide();
    }
  });

  // $(BULK_UPDATE_MENU_CLASSNAME + " #key-select").change(function() {
  //   $(BULK_UPDATE_MENU_CLASSNAME + " #attribute-value-select option").remove();
  //   var key = $(this).val();
  //   if(key == "") return 0;

  //   $.ajax({
  //     url: "/channels/attribute_values",
  //     method: "GET",
  //     data: { "key": key },
  //     success: (response) => {
  //       $.each(response["attribute_values"], function (i, item) {
  //           $('.channel-update-menu #attribute-value-select').append($('<option>', { 
  //               value: item.value,
  //               text : item.value 
  //           }));
  //       });

  //     },
  //     error: function(response) {
  //       console.log('Something went wrong. Please try again.');
  //     }
  //   });
  // })

  $(BULK_UPDATE_MENU_CLASSNAME + " #bulk_update_channels_form").submit(function(e) {
    console.log("submitted")
    var checked_ids = $(".channel-checkbox:checked").map(function(id, elem) { return $(elem).attr("id")})
    $(BULK_UPDATE_MENU_CLASSNAME + " #bulk_update_channels_form .channel_ids").val(checked_ids.toArray());

    const params = new URLSearchParams(window.location.search);
    const paramsObj = {};
    for (const key of params.keys()) {
        if (params.getAll(key).length > 1) {
          paramsObj[key.replace('[]', '')] = params.getAll(key);
        } else if (key.includes('[]')) {
          paramsObj[key.replace('[]', '')] = params.getAll(key);
        }
        else {
          paramsObj[key] = params.get(key);
        }
    }
    $('#channel-search-query-field').val(JSON.stringify(paramsObj));
  })

  $('#new-list-name-container').keypress(function(e){
    if(e.which == 13){
      if (confirm('Are You Sure?')){
        var form = $("#channels_add_to_list_form")
        if(window.location.pathname == "/channels"){
          var checked_ids = $(".channel-checkbox:checked").map(function(id, elem) { return $(elem).attr("id")})
          $(BULK_UPDATE_MENU_CLASSNAME + " #channels_add_to_list_form .channel_ids").val(checked_ids.toArray());
        }
        form.submit();
      }
    }
  });

  $("#select-all-channels").change(function(){
    var checked = $(this).prop('checked')

    if(checked){
      $('.channel-checkbox').prop('checked', true);
      $('#select-channels-query-params').prop('checked', false);
      $(BULK_UPDATE_MENU_CLASSNAME + " .bulk_menu_btn").prop('disabled', false);
    } else {
      $('.channel-checkbox').prop('checked', false);
      $(BULK_UPDATE_MENU_CLASSNAME + " .bulk_menu_btn").prop('disabled', true);
    }
  })

  $("#select-channels-query-params").change(function(){
    var checked = $(this).prop('checked')

    if(checked){
      $('.channel-checkbox').prop('checked', false);
      $('#select-all-channels').prop('checked', false);
      $(BULK_UPDATE_MENU_CLASSNAME + " .bulk_menu_btn").prop('disabled', false);
    } else {
      $(BULK_UPDATE_MENU_CLASSNAME + " .bulk_menu_btn").prop('disabled', true);
    }
  })

  $('body').on("change", '.channel-checkbox', function(){

    $('#select-channels-query-params').prop('checked', false);
    if($(".channel-checkbox:checked").length > 0 ){
      $(BULK_UPDATE_MENU_CLASSNAME + " .bulk_menu_btn").prop('disabled', false);
    } else {
      $(BULK_UPDATE_MENU_CLASSNAME + " .bulk_menu_btn").prop('disabled', true);
    }

  });

  $('#check-filter-results').on('click', function(){
    getSearchResults()
  })

  // $('#check-company-filter-results').on('click', function(){
  //   filter_names = []
  //   let url = new URL(window.location.href);
  //   let params = new URLSearchParams(url.search);

  //   $('#company-filters .dropdown-menu').each(function(i, elem){
  //     var filter_name = $(elem).attr('name')
  //     console.log(filter_name)

  //     params.delete(`${filter_name}[]`)
  //     var checked = $(`.${filter_name}-dropdown-filter:checkbox:checked`)

  //     checked.each(function(i, element) {
  //       params.append(`${filter_name}[]`, element.id)
  //     });
  //   })

  //   console.log(params.toString())

  //   window.location.href = window.location.href.split('?')[0] + '?' + params.toString()
  // })

  // $('#check-people-filter-results').on('click', function(){
  //   filter_names = []
  //   let url = new URL(window.location.href);
  //   let params = new URLSearchParams(url.search);

  //   $('#people-filters .dropdown-menu').each(function(i, elem){
  //     var filter_name = $(elem).attr('name')
  //     console.log(filter_name)

  //     params.delete(`${filter_name}[]`)
  //     var checked = $(`.${filter_name}-dropdown-filter:checkbox:checked`)

  //     checked.each(function(i, element) {
  //       params.append(`${filter_name}[]`, element.id)
  //     });
  //   })

  //   console.log(params.toString())

  //   window.location.href = window.location.href.split('?')[0] + '?' + params.toString()
  // })

  $(".add-new-list-toggle-button").on('click', function(event){
    event.preventDefault();
    $('#new-list-form').removeClass('d-none')
    $('#new-list-field').removeClass('d-none')
    $('#new-list-field input').prop('disabled', false)
    $(this).hide()
  })

  $('body').on('keydown', FORM_CONTAINER_ID + ' #attributes_field .option-field input[type="text"]', function(e) {
    if (e.keyCode == 13) {
      addNewOptionField(FORM_CONTAINER_ID, "channel");
    }
  });

  $('body').on('click', FORM_CONTAINER_ID + ' .add-button', function(e) {
    e.preventDefault();
    addNewOptionField(FORM_CONTAINER_ID, "channel");
    initializeAttributeKeys($(KEYS_CLASSNAME).last(), KEYS_ENDPOINT);
  });

  initializeAttributeKeys($(KEYS_CLASSNAME).last(), KEYS_ENDPOINT);

  $('body').on('select2:select', KEYS_CLASSNAME, function (e) {
    var value_select_element = $(this).parent().next().find("select");
    var value = $(this).find(':selected').val();
    console.log(value)
    initializeAttributeValues(value_select_element, value, true)
  })

  function getSearchResults(){
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    params.delete("platform_name[]")
    $('.platform-dropdown-filter:checked').each(function() {
      params.append("platform_name[]", $(this).attr('id'))
    });

    if( $('#search-term-text').val()){
      var val = $('#search-term-text').val()
      params.set('term', val)
    }

    if( $('#monitor-top-filters #keyword').val()){
      var val = $('#monitor-top-filters #keyword').val()
      params.set('keyword', val)
    }

    console.log(params.toString())

    window.location.href = window.location.href.split('?')[0] + '?' + params
  }

  $('form#channel-save-search-form').submit(function(e) {
    $('#save-search-query-field').val(JSON.stringify(parseParams(window.location.search)));
  });

})
  

export { parseParams };
